// components/EDLeadForm.js
import React, { useState, useEffect } from "react";
import edMantra from "../../services/edMantra";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ErrorPopup from "../Errors/ErrorPopup"; // Import ErrorPopup component
import moment from "moment"; // Import moment library for date formatting

const MarketingEditLead = (props) => {
  const { leadObject, handleSave, setFileData, allRemarks = [] } = props;
  const { data } = useSelector((state) => state?.currentSession?.userInfo);
  const [errors, setErrors] = useState({});

  // Initialize editableLead state with leadObject and nextfollow
  const [editableLead, setEditableLead] = useState({
    ...leadObject,
    nextfollow: null, // You can set nextfollow to null initially
  });

  const [marketingExecutive, setMarketingExecutive] = useState([]);
  const [marketingManager, setMarketingManager] = useState([]);
  const [vendorManagementExecutive, setVendorManagementExecutive] = useState([]);
  const [vendorManagementManager, setVendorManagementManager ] = useState([]);
     const [allEmployees, setAllEmployees] = useState([]);
  // Handle nextfollow separately
  const [selectedDate, setSelectedDate] = useState(
    editableLead.nextfollow ? new Date(editableLead.nextfollow) : null
  );

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  console.log(allRemarks);
  console.log(leadObject, "*************************");

  const handleFileChange = (e) => {
    setFileData(e.target.files[0]);
  };

   const getAllEmployees = async () => {
        try {
          const allEmployees = await edMantra.getAllEmployees();
          setAllEmployees(allEmployees.data.data);
        } catch (err) {
          console.error(err, "Error fetching data");
        }
      };

  const getAllMarketingExecutive = async () => {
    const result = await edMantra.getAllMarketingExecutive();
    setMarketingExecutive(result?.data?.data);
  };
  const getAllMarketingManager = async () => {
    const result = await edMantra.getAllMarketingManager();
    setMarketingManager(result?.data?.data);
  };

  const getAllVendorManagementExecutive = async () => {
    const result = await edMantra.getAllVendorManagementExecutive();
    setVendorManagementExecutive(result?.data?.data);
  };

  const getAllVendorManagementManager = async () => {
    const result = await edMantra.getAllVendorManagementManager();
    setVendorManagementManager(result?.data?.data);
  };

  const formatDateforleadremarkdate = (dateString) => { //for lead craetedAt and updatedAt
    const date = new Date(dateString);
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true // Include this option for 12-hour format
    };
    return date.toLocaleDateString('en-GB', options);
  };
  
  //-----------------validation-------------------------------------

  const validateForm = (editableLead) => {
    let errors = {};
    if (!/^[a-zA-Z\s]+$/.test(editableLead.clientName)) {
      errors.clientName = "Only Characte is allowed in Name";
    }

    if (!/^\d{10}$/.test(editableLead.pocMobile)) {
      errors.pocMobile = "First Phone number must be exactly 10 digits long";
    }

    if (!/\S+@\S+\.\S+/.test(editableLead.pocEmail)) {
      errors.pocEmail = "Email address is invalid";
    }

    if (!/^[a-zA-Z\s]+$/.test(editableLead.pocDesignation)) {
      errors.pocDesignation = "Only Characte is allowed in  Designation";
    }
    if (!/^[a-zA-Z\s]+$/.test(editableLead.decisionMaker)) {
      errors.decisionMaker = "Only Characte is allowed in Decision Maker";
    }

    if (!/^\d{10}$/.test(editableLead.dmMobile)) {
      errors.dmMobile = "Second Phone number must be exactly 10 digits long";
    }

    if (!/\S+@\S+\.\S+/.test(editableLead.dmEmail)) {
      errors.dmEmail = "Email address is invalid";
    }

    if (!/^[a-zA-Z\s]+$/.test(editableLead.dmDesignation)) {
      errors.dmDesignation = "Only Characte is allowed in City/Town";
    }

    // if (!/^[a-zA-Z\d\s,]+$/.test(editableLead.address)) {
    //   errors.address = "Only Characte is allowed in Address";
    // }

    if (!/^[a-zA-Z\d\s,]+$/.test(editableLead.location)) {
      errors.location = "Only Characte is allowed in Location";
    }

    if (editableLead.nextfollow === null) {
      errors.nextfollow = "You cannot leave the next follow-up date blank";
    }

    return errors;
  };

  const handleSaveLead = () => {
    const errors = validateForm(editableLead);
    if (Object.keys(errors).length === 0) {
      // No validation errors, proceed with saving
      handleSave(editableLead); // Call handleSave function passed from props
    } else {
      // Validation errors present, set errors to state
      setErrors(errors);
    }
  };

  //------------------validations-------------------------------

  useEffect(() => {
    getAllMarketingManager();
    getAllMarketingExecutive();
    getAllVendorManagementExecutive();
    getAllVendorManagementManager();
    getAllEmployees();
  }, [leadObject]);

  return (
    <section>
      <div className="row p-0 m-0">
        <div className="col-md-8 mx-auto">
          <h5 className="mb-3">Edit Marketing Lead</h5>
          <hr className="my-4 border border-dark" />

          <div className="row">
            {Object.keys(errors).length > 0 && <ErrorPopup errors={errors} />}

            {/* Client Name */}
            <div className="col-md-4 mb-3">
              <div className="form-group">
                <label>Client/College Name:</label>
                <input
                  type="text"
                  className="form-control"
                  value={editableLead?.clientName || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      clientName: e.target.value,
                    }))
                  }
                  required
                />
              </div>
            </div>

            {/* College Category */}
            <div className="col-md-3 mb-3">
              <div className="form-group">
                <label>Category of Client/College:</label>
                <select
                  className="form-control"
                  value={editableLead?.collegeCategory || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      collegeCategory: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Category</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </select>
              </div>
            </div>

            {/* Brief about College */}
            <div className="col-md-3 mb-3">
              <div className="form-group">
                <label>Brief about Client/College:</label>
                <input
                  type="text"
                  placeholder="Name of the College or Client"
                  className="form-control"
                  value={editableLead?.brief || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      brief: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            {/* Point of Contact */}
            <div className="col-md-4 mb-3">
              <div className="form-group">
                <label>Point of Contact:</label>
                <input
                  type="text"
                  className="form-control"
                  value={editableLead?.pocName || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      pocName: e.target.value,
                    }))
                  }
                  required
                />
              </div>
            </div>

            {/* Mobile Number */}
            <div className="col-md-4 mb-3">
              <div className="form-group">
                <label>Mobile Number:</label>
                <input
                  type="text"
                  className="form-control"
                  value={editableLead?.pocMobile || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      pocMobile: e.target.value,
                    }))
                  }
                  required
                />
              </div>
            </div>

            {/* Email */}
            <div className="col-md-4 mb-3">
              <div className="form-group">
                <label>Email:</label>
                <input
                  type="text"
                  className="form-control"
                  value={editableLead?.pocEmail || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      pocEmail: e.target.value,
                    }))
                  }
                  required
                />
              </div>
            </div>

            <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Designation:</label>
            <input
              type="text"
              placeholder="Designation of Primary Contact Person"
              className="form-control"
              value={editableLead.pocDesignation}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  pocDesignation: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Address:</label>
            <input
              type="text"
              placeholder="Address of the College/Client"
              className="form-control"
              value={editableLead.address}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  address: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Location:</label>
            <input
              type="text"
              placeholder="Location of the College/Client"
              className="form-control"
              value={editableLead.location}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  location: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Objective:</label>
            <select
              className="form-control"
              value={editableLead.objective}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  objective: e.target.value,
                }))
              }
            >
              <option value="NA">Select Campaign Purpose</option>
              <option value="Workshop">Workshop</option>
              <option value="Seminar">Seminar</option>
              <option value="LMS only">LMS only</option>
              <option value="LMS Hybrid">LMS Hybrid</option>
              <option value="Corporate Training">Corporate Training</option>
              <option value="Job Fair">Job Fair</option>
              <option value="Webinar">Webinar</option>
              <option value="Event">Event</option>
              <option value="Recruitment">Recruitment</option>
              <option value="Other">Other</option>
            </select>

            {/* Show input field when 'Other' is selected */}
            {editableLead.objective === "Other" && (
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Please specify"
                value={editableLead.otherObjective || ""}
                onChange={(e) =>
                  setEditableLead((prevState) => ({
                    ...prevState,
                    otherObjective: e.target.value,
                  }))
                }
              />
            )}
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Intrest Level:</label>
            <select
              className="form-control"
              value={editableLead.interestLevel}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  interestLevel: e.target.value,
                }))
              }
            >
              <option value="NA">Select Intrest Level</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low only">Low</option>
            </select>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Status:</label>
            <select
              className="form-control"
              value={editableLead.status}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  status: e.target.value,
                }))
              }
            >
              <option value="NA">Select Status</option>
              <option value="Approached">Approached</option>
              <option value="Proposal Sent">Proposal Sent</option>
              <option value="Meeting Done">Meeting Done</option>
              <option value="Meeting Cancelled">Meeting Cancelled</option>
              <option value="Meeting Pending">Meeting Pending</option>
              <option value="Agreement Done">Agreement Done</option>
              <option value="LMS Purchased">LMS Purchased</option>
              <option value="Need Discussion">Need Discussion</option>
              <option value="Proposal Rejected">Proposal Rejected</option>
              <option value="Renewal Required">Renewal Required</option>
              <option value="Deal Closed">Deal Closed</option>
              <option value="Workshop/Seminar Proposed">
                Workshop/Seminar Proposed
              </option>
              <option value="Under Process">Under Process</option>
            </select>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Source:</label>
            <select
              className="form-control"
              value={editableLead.source}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  source: e.target.value,
                }))
              }
            >
              <option value="">Select Source</option>
              <option value="Just Dial">Just Dial</option>
              <option value="Walk-in">Walk-in</option>
              <option value="Google Search">Google Search</option>
              <option value="Instagram">Instagram</option>
              <option value="Facebook">Facebook</option>
              <option value="Reference">Reference</option>
              <option value="Data Scraper Tool">Data Scraper Tool</option>
              <option value="Purchased Data">Purchased Data</option>
              <option value="Paid Ads">Paid Ads</option>
              <option value="Event/Activity">Event/Activity</option>
              <option value="Linkedin">Linkedin</option>
              <option value="Job Portals">Job Portals</option>
              <option value="Self Data">Self Data</option>
              <option value="Other">Other</option>
            </select>

            {/* Show input field when 'Other' is selected */}
            {editableLead.source === "Other" && (
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Please specify"
                value={editableLead.otherSource || ""}
                onChange={(e) =>
                  setEditableLead((prevState) => ({
                    ...prevState,
                    otherSource: e.target.value,
                  }))
                }
              />
            )}
            {editableLead.source === "Reference" && (
              <>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Name of the Reference"
                  value={editableLead.refSourceName || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      refSourceName: e.target.value,
                    }))
                  }
                />

                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Contact of the Reference"
                  value={editableLead.refSourceMobile || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      refSourceMobile: e.target.value,
                    }))
                  }
                />
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div>
          <hr class="my-4 border border-dark w-100"></hr>
        </div>
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Decision Maker:</label>
            <input
              type="text"
              placeholder="Name of the Decision Maker"
              className="form-control"
              value={editableLead.decisionMaker}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  decisionMaker: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Mobile No:</label>
            <input
              type="text"
              placeholder="Contact of the Decision Maker"
              className="form-control"
              value={editableLead.dmMobile}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  dmMobile: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Designation:</label>
            <input
              type="text"
              placeholder="Designation of the Decision Maker"
              className="form-control"
              value={editableLead.dmDesignation}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  dmDesignation: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Email:</label>
            <input
              type="text"
              placeholder="Email of the Decision Maker"
              className="form-control"
              value={editableLead.dmEmail}
              onChange={(e) =>
                setEditableLead((prevState) => ({
                  ...prevState,
                  dmEmail: e.target.value,
                }))
              }
            />
          </div>
        </div>

            {/* Preferred Contact Timing */}
            <div className="col-md-3 mb-3">
              <div className="form-group">
                <label>Preferred Contact Timing:</label>
                <input
                  type="time"
                  className="form-control"
                  value={editableLead?.preferredContactTiming || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      preferredContactTiming: e.target.value,
                    }))
                  }
                  step="60"
                />
              </div>
            </div>

            {/* Follow-Up Date */}
            <div className="col-md-4 mb-3">
              <div className="form-group">
                <label>Next Follow-Up Date:</label>
                <DatePicker
                  className="form-control"
                  selected={selectedDate}
                  onChange={(date) => {
                    if (date) {
                      date.setHours(11);
                      date.setMinutes(0);
                    }
                    setSelectedDate(date);

                    setEditableLead((prevState) => ({
                      ...prevState,
                      nextfollow: date
                        ? moment.utc(date).format("YYYY-MM-DDTHH:mm:ss[Z]")
                        : null,
                    }));
                  }}
                  placeholderText="Select Follow-Up Date"
                  required
                />
              </div>
            </div>

            {/* Assign To */}
            <div className="col-md-4 mb-3">
              <div className="form-group">
                <label>Assign To:</label>
                <select
                  className="form-control"
                  value={editableLead?.telecaller || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      telecaller: e.target.value,
                    }))
                  }
                  required
                >
                  <option value="Not assigned">Select Assignee</option>
                  {[...marketingExecutive, 
                  ...marketingManager, 
                  ...vendorManagementExecutive, 
                  ...vendorManagementManager, ...allEmployees].map(
                    (item, index) => (
                      <option key={index} value={item?.empId}>
                        {`${item?.fname} ${item?.mname} ${item?.lname}`}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>

            {/* Comments */}
            <div className="col-md-4 mb-3">
              <div className="form-group">
                <label>Comments:</label>
                <input
                  type="text"
                  className="form-control"
                  value={editableLead?.remark || ""}
                  onChange={(e) =>
                    setEditableLead((prevState) => ({
                      ...prevState,
                      remark: e.target.value,
                    }))
                  }
                  required
                />
              </div>
            </div>

            {/* Save Button */}
            <div className="col-12 text-center mt-3">
              <button
                className="btn btn-primary w-50"
                type="submit"
                onClick={() => handleSaveLead(editableLead)}
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {/* Remarks Section */}
        <div className="col-md-4 mx-auto border m-2 pt-2">
  <h5>Remarks</h5>
  <div className="p-2" style={{ height: '30rem', overflowY: 'scroll' }}>
            {allRemarks?.length > 0 ?
              allRemarks?.map((obj, index) => {
                return (
                  <>
                    <div className="card p-0 mt-2 border-0 shadow ">
                      <div className="card-body p-2 m-0">
                        <p className=" text-dark">{obj?.remark}</p>
                        <div className="d-flex  text-secondary p-0 m-0 justify-content-between">
                          <p style={{ fontSize: '14px' }}>{formatDateforleadremarkdate(obj?.createdAt)}</p>
                          <p style={{ fontSize: '14px' }}>{`${obj?.employee?.fname} (${obj?.employee?.role})`}</p>
                        </div>
                      </div>
                    </div>
                  </>
                );
              }) : <p className="fs-6 text-secondary">Remarks not available</p>}
          </div>
</div>

      </div>
    </section>
  );
};

export default MarketingEditLead;
